module.exports = __webpack_public_path__ + "img/arrow-silver.395aa7da.png";